import { render } from "./unionSelectModel.vue?vue&type=template&id=2125c578"
import script from "./unionSelectModel.vue?vue&type=script&lang=js"
export * from "./unionSelectModel.vue?vue&type=script&lang=js"

import "./unionSelectModel.vue?vue&type=style&index=0&id=2125c578&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__